module.exports = __webpack_public_path__ + "img/log-in-02.c3bc520c.svg";